import { render, staticRenderFns } from "./PageAdminIndex.vue?vue&type=template&id=9fbfaf5c"
import script from "./PageAdminIndex.vue?vue&type=script&lang=js"
export * from "./PageAdminIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports